import React, { useState, useMemo } from "react";
import styled from "styled-components";

const Avatar = styled.div`
    width: ${({ $size }) => $size}px;
    height: ${({ $size }) => $size}px;
    border-radius: 8px;
    background: #f3f4f6;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    overflow: hidden;
    font-size: ${({ $size }) => Math.round($size * 0.36)}px;
    font-weight: 700;
    color: #374151;
    user-select: none;
`;

const Img = styled.img`
    width: 60%;
    height: 60%;
    object-fit: contain;
    display: block;
`;

function faviconCandidates(url) {
    try {
        const href = /^https?:\/\//i.test(url) ? url : `https://${url}`;
        const u = new URL(href);
        const domain = u.hostname.replace(/^www\./, "");
        return [
            `https://www.google.com/s2/favicons?domain=${domain}&sz=64`,
            `https://icons.duckduckgo.com/ip3/${domain}.ico`,
            `${u.origin}/favicon.ico`,
        ];
    } catch {
        return [];
    }
}

function initials(name = "") {
    return name.trim().slice(0, 2).toUpperCase() || "?";
}

/**
 * Shows a site favicon with automatic fallback:
 *   /favicon.ico → DuckDuckGo CDN → initials
 *
 * Props:
 *   url  – the website URL (used to derive favicon sources)
 *   name – fallback text for initials
 *   size – avatar size in px (default 40)
 */
export default function SiteFavicon({ url, name = "", size = 40 }) {
    const candidates = useMemo(() => faviconCandidates(url), [url]);
    const [idx, setIdx] = useState(0);
    const src = candidates[idx];

    return (
        <Avatar $size={size} aria-label={`${name} logo`}>
            {src ? (
                <Img
                    src={src}
                    alt=""
                    draggable={false}
                    onError={() => setIdx((i) => i + 1)}
                />
            ) : (
                initials(name)
            )}
        </Avatar>
    );
}
